import { FormikValues } from 'formik'

export const trimValues = (values?: FormikValues | null) => {
  if (!values) {
    return null
  }

  return Object.keys(values).reduce((acc, key) => {
    if (typeof values[key] === 'string') {
      acc[key] = values[key].trim()
    } else if (Array.isArray(values[key])) {
      acc[key] = values[key].map((item) => {
        if (typeof item === 'string') {
          return item.trim()
        } else if (typeof item === 'object' && !(item instanceof Date)) {
          return trimValues(item)
        }
        return item
      })
    } else if (typeof values[key] === 'object' && !(values[key] instanceof Date)) {
      acc[key] = trimValues(values[key])
    } else {
      acc[key] = values[key]
    }

    return acc
  }, {} as FormikValues)
}
